export interface ApiErrorDetail {
  path?: string;
  message: string;
}

// Every failed request rejects with an ApiError. Status 0 means the request never got an HTTP
// response (timeout or network failure).
export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    message: string,
    readonly requestId?: string,
    readonly details: ApiErrorDetail[] = [],
  ) {
    super(message);
    this.name = 'ApiError';
  }

  // Worth retrying: no response at all, or a server-side failure. 4xx answers are final.
  get isRetryable(): boolean {
    return this.status === 0 || this.status >= 500;
  }
}
